<template>
  <div class="grid gap-4">
    <div v-if="carePlan.id" class="mb-4">
      <label class="text-gray-700 text-sm font-bold mb-2" for="active"> Active </label>
      {{ carePlanLocal.active ? 'Yes' : 'No' }}
    </div>
    <div class="mb-4">
      <div class="flex items-center mb-2">
        <label class="block text-gray-700 text-sm font-bold mr-2" for="is_rpm_restarting">
          Is RPM Restarting?
        </label>

        <el-tooltip
            effect="light"
            content="If checked 99453 will be billed."
            placement="right"
        >
          <span class="inline-flex cursor-pointer">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.29 15.29C11.247 15.3375 11.2069 15.3876 11.17 15.44C11.1322 15.4957 11.1019 15.5563 11.08 15.62C11.0512 15.6767 11.0309 15.7374 11.02 15.8C11.0151 15.8666 11.0151 15.9334 11.02 16C11.0166 16.1312 11.044 16.2613 11.1 16.38C11.1449 16.5041 11.2166 16.6168 11.3099 16.7101C11.4032 16.8034 11.5159 16.8751 11.64 16.92C11.7597 16.9729 11.8891 17.0002 12.02 17.0002C12.1509 17.0002 12.2803 16.9729 12.4 16.92C12.5241 16.8751 12.6368 16.8034 12.7301 16.7101C12.8234 16.6168 12.8951 16.5041 12.94 16.38C12.9844 16.2584 13.0048 16.1294 13 16C13.0008 15.8684 12.9755 15.7379 12.9258 15.6161C12.876 15.4943 12.8027 15.3834 12.71 15.29C12.617 15.1963 12.5064 15.1219 12.3846 15.0711C12.2627 15.0203 12.132 14.9942 12 14.9942C11.868 14.9942 11.7373 15.0203 11.6154 15.0711C11.4936 15.1219 11.383 15.1963 11.29 15.29ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17316C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87103 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21446 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 7C11.4731 6.99966 10.9553 7.13812 10.4989 7.40144C10.0425 7.66476 9.66347 8.04366 9.4 8.5C9.32765 8.61382 9.27907 8.74109 9.25718 8.87418C9.23529 9.00726 9.24054 9.14339 9.27263 9.27439C9.30472 9.40538 9.36297 9.52853 9.44389 9.63643C9.5248 9.74433 9.62671 9.83475 9.74347 9.90224C9.86024 9.96974 9.98945 10.0129 10.1233 10.0292C10.2572 10.0454 10.393 10.0345 10.5225 9.99688C10.6521 9.9593 10.7727 9.89591 10.8771 9.81052C10.9814 9.72513 11.0675 9.6195 11.13 9.5C11.2181 9.34739 11.345 9.22078 11.4977 9.13298C11.6505 9.04517 11.8238 8.9993 12 9C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V12.82C13.6614 12.58 14.2174 12.1152 14.5708 11.5069C14.9242 10.8985 15.0525 10.1853 14.9334 9.49189C14.8143 8.79849 14.4552 8.16902 13.919 7.71351C13.3828 7.25801 12.7035 7.00546 12 7Z" fill="#D4D4D4" />
            </svg>
          </span>
        </el-tooltip>
      </div>

      <el-checkbox v-model="carePlanLocal.is_rpm_restarting" id="is_rpm_restarting" />
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="health_condition"> Health condition <span
          class="required">*</span> </label>
      <input v-model="carePlanLocal.health_condition" class="shadow appearance-none border rounded w-full py-2 px-3 input__registerPatient text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="health_condition" type="text" placeholder=""/>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="rpm_note"> Select Template </label>
      <select id="rpm_note" v-on:change="templateChange" v-model="selectedTemplate"
              class="shadow appearance-none border rounded w-full py-2 px-3 input__registerPatient text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
        <option value=""></option>
        <option v-for="template in templates" v-bind:value="template" v-bind:key="template.id">
          {{ template.name }}
        </option>
      </select>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="notes"> Notes <span class="required">*</span>
      </label> <textarea ref="rpmNotesRef" @keydown.tab.prevent="tabTemplate('rpmNotesRef')" v-model="notes" rows="4"
                         class="shadow appearance-none border rounded w-full py-2 px-3 input__registerPatient text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         id="notes" placeholder=""></textarea>
    </div>

    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="rpm_note">End Date</label>
      <input v-model="carePlanLocal.end_date" type="date"
             class="shadow appearance-none border rounded w-full py-2 px-3 input__registerPatient text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
             id="end_date" />
    </div>

    <div>
      <label class="block text-gray-700 text-sm font-bold mb-2" for="icd_codes">
        ICD Codes Selected:
      </label>
    </div>

    <div class="mb-4">
      <div v-if="icd_codes_selected.length">
        <ul>
          <li v-for="(code, index) in icd_codes_selected" :key="code.id">
            {{ code.code }} - {{ code.short_desc }}
            <el-button icon="el-icon-close" circle @click="removeCode(index)"></el-button>
          </li>
        </ul>
      </div>
      <div v-else>
        No ICD Codes Selected.
      </div>

      <hr class="mt-4 mb-4" />

      <div>
        <el-input style="width: 50%" v-model="icd_codes_search" @input="debounceIcdCodeSearch" placeholder="Search" prefix-icon="el-icon-search" clearable :disabled="loading" class="mb-4" />
        <div v-if="icd_codes.length > 0 && !loading">
          <ul>
            <li v-for="(code, index) in icd_codes" :key="index" v-if="!icd_codes_selected.find(selectedCode => selectedCode.id === code.id)">
              <a href="#" @click.prevent="addCode(index)">{{ code.code }} - {{ code.short_desc }}</a>
            </li>
          </ul>
        </div>
        <div v-else-if="icd_codes_search.length">
          <span v-if="loading" class="el-icon-loading"></span>
          <span v-else>No ICD Codes Found.</span>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="rpm_note"> Vital Alerts </label>
      <div class="grid grid-cols-2">
        <div v-for="(alert) in carePlanLocal.alerts" v-bind:key="alert.type" class="container mb-4 border rounded p-4">
          <AlertInputs :alert="alert"
                       v-on:update:min="alert.min = $event"
                       v-on:update:max="alert.max = $event"
                       v-on:update:min_warning="alert.min_warning = $event"
                       v-on:update:max_warning="alert.max_warning = $event"
                       v-on:update:frequency="alert.frequency = $event"
          />
        </div>
      </div>
    </div>

    <Collapse class="mb-4">
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="rpm_note">Start Date</label>
        <input v-model="carePlanLocal.start_date" type="date"
               class="shadow appearance-none border rounded w-full py-2 px-3 input__registerPatient text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
               id="start_date" />
        <p>*Please do not update unless fixing equipment delivery date*</p>
      </div>
    </Collapse>
  </div>
</template>
<script>
import Template from "@/mixins/Template";
import _ from "lodash";
import Vue from "vue";
import Collapse from "@/components/Collapse.vue";
import AlertInputs from "@/components/AlertInputs.vue";

export default {
  components: {AlertInputs, Collapse},
  mixins: [Template],
  name: 'RpmCarePlan',
  model: {
    prop: 'carePlan',
    event: 'carePlanUpdated',
  },
  data() {
    return {
      token: null,
      loading: false,
      icd_codes: [],
      icd_codes_search: '',
      icd_codes_selected: [],
    }
  },
  props: {
    carePlan: {},
    templates: {}
  },
  watch: {
    notes: function(notes) {
      this.carePlan.notes = notes;
    },
    icd_codes_selected: function(icd_codes_selected) {
      this.carePlan.icd_codes = icd_codes_selected;
    }
  },
  created: async function () {
    this.token = await this.$auth.getTokenSilently();
  },
  mounted: function() {
    this.carePlan.active = !! this.carePlan.active;
    this.notesOriginal = this.carePlan.notes;
    this.notes = this.carePlan.notes;
    this.icd_codes_selected = this.carePlan.icd_codes;
  },
  computed: {
    carePlanLocal: {
      get: function() {
        return this.carePlan
      },
      set: function(value) {
        this.$emit('carePlanUpdated', value)
      }
    }
  },
  methods: {
    removeCode(index) {
      this.icd_codes_selected.splice(index, 1);
    },
    addCode(index) {
      this.icd_codes_selected.push(this.icd_codes[index]);
    },
    debounceIcdCodeSearch: _.debounce(function () {
      this.searchIcdCodes();
    }, 2000),
    searchIcdCodes: function() {
      if (this.icd_codes_search.length >= 2) {
        this.icd_codes = [];
        this.loading = true;
        Vue.$http.get(`/api/rpm_ccm_dashboard/search_icd_codes`, {params: { search: this.icd_codes_search, token: this.token }})
            .then((res) => {
              this.icd_codes = res.data.data;
            }).catch((error) => {
          this.$awn.alert(error.response.data.message);
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  }
}
</script>
<style scoped>


.ico__actionPanel a {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #292929;
  padding: 10px 0px;
}

.select__arrow-container svg {
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translate(0, -50%);
  height: 12px;
  width: 12px;
  z-index: 999;
}

.btn__back-container svg {
  top: -2px;
  position: relative;
  margin-right: 5px;
}

.table__modify tr th div {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  text-transform: capitalize;
  align-items: center;
  color: #292929;
  white-space: nowrap;
}

.table__modify tr th div svg {
  color: #9a9a9a;
}

.table__modify tbody tr {
  font-family: "Lato";
  font-style: normal;
  color: #292929;
}

.grid-cols-2 div:nth-child(odd) {
  margin-right: 12px;
}

.grid-cols-2 div:nth-child(even) {
  margin-left: 12px;
}

.dialog__body label {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #292929;
}

.panel__agreement .txt__location strong {
  font-weight: 700;
}

.input__registerPatient {
  background: #eeeeee;
  color: #292929;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
}

@media (max-width: 575.98px) {

}
</style>